import Vue from 'vue'
import { AXIOS_REQUESTS, ERRORS, ACCOUNT } from '@/constants/store.js'

const addAdditionalRequestSettings = async (model, dispatch, account) => {
  // если было открыто несколько вкладок и в одной из вкладок
  // пользователь вошел/вышел из системы
  // делаем для соседних вкладок актуальное состояние пользователя
  await dispatch(`${ACCOUNT.NAMESPACE}/${ACCOUNT.ACTIONS.RELOAD_LOGIN_STATUS_FROM_LOCAL_STORAGE}`, null, { root: true })
  const settings = model.settings || {}
  const headers = settings.headers || {}
  if (account?.token) {
    headers.token = account.token
  }

  if (headers) {
    settings.headers = headers
  }
  return settings
}

const actions = {
  async [AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST] ({ dispatch, rootState }, model) {
    try {
      const settings = await addAdditionalRequestSettings(model, dispatch, rootState.account)
      return await Vue.axios.get(encodeURI(model.url).replace(/#/g, '%23'), settings)
    } catch (error) {
      await dispatch(ERRORS.ACTIONS.SHOW_AND_THROW_ERROR, error, { root: true })
    }
  },
  async [AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST] ({ dispatch, rootState }, model) {
    try {
      const settings = await addAdditionalRequestSettings(model, dispatch, rootState.account)
      return await Vue.axios.put(model.url, model.model, settings)
    } catch (error) {
      await dispatch(ERRORS.ACTIONS.SHOW_AND_THROW_ERROR, error, { root: true })
    }
  },
  async [AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST] ({ dispatch, rootState }, model) {
    try {
      const settings = await addAdditionalRequestSettings(model, dispatch, rootState.account)
      return await Vue.axios.post(model.url, model.model, settings)
    } catch (error) {
      await dispatch(ERRORS.ACTIONS.SHOW_AND_THROW_ERROR, error, { root: true })
    }
  },
  async [AXIOS_REQUESTS.ACTIONS.DELETE_AXIOS_REQUEST] ({ dispatch, rootState }, model) {
    try {
      const settings = await addAdditionalRequestSettings(model, dispatch, rootState.account)
      await Vue.axios.delete(model.url, settings)
    } catch (error) {
      await dispatch(ERRORS.ACTIONS.SHOW_AND_THROW_ERROR, error, { root: true })
    }
  }
}

export default {
  actions
}
